import React from 'react'
import xtensiv from '../../../../assets/Extensiv.webp'
import { ProdCreationTable } from './ProdCreationTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const ExtensivTools = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Warehouse"
        title="File converters"
        subtitle="Convert Extensiv product creation, vendor SKU, and listing files."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Warehouse', to: '/warehouse-tools' },
          { label: 'Extensiv' },
        ]}
        status={
          <div className="h-8 w-28">
            <img className="h-full w-full object-contain" src={xtensiv} alt="Extensiv" />
          </div>
        }
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <ProdCreationTable />
      </div>
    </AppShell>
  )
}

export default ExtensivTools
